<div
  [ngClass]="{
    'page-input': inputConfig?.usageCase === EInputUsage.Page,
    'modal-input': inputConfig?.usageCase === EInputUsage.Modal
  }"
  class="input-custom"
>
  <div class="input-wrapper">
    <ng-container *ngIf="inputConfig?.type === EInputCustomType.Textarea; else regularInput">
      <textarea
        [formControl]="formControl"
        [class.invalid]="isError"
        [placeholder]="inputConfig?.placeholder"
        [value]="value"
        (focusout)="focusOut(formControl)"
        (input)="change()"
        class="form-control textarea"
        rows="2"
        minlength="0"
      ></textarea>
    </ng-container>

    <ng-template #regularInput>
      <input
        [formControl]="formControl"
        [class.invalid]="isError"
        [min]="inputConfig.value"
        [placeholder]="inputConfig?.placeholder"
        [type]="hide ? inputConfig?.type : EInputCustomType.Text"
        [value]="value"
        (focusout)="focusOut(formControl)"
        (input)="change()"
        class="form-control"
      />
    </ng-template>

    <ng-container *ngIf="inputConfig.type === 'password'">
      <ng-container *ngIf="!hide">
        <stxt-svg-icon
          [iconConfig]="passwordVisibleIcon"
          (click)="changeType(true)"
          class="password-eye"
        ></stxt-svg-icon>
      </ng-container>

      <ng-container *ngIf="hide">
        <stxt-svg-icon
          [class.invalid-svg]="isError"
          [iconConfig]="passwordInvisibleIcon"
          (click)="changeType(false)"
          class="password-eye"
        ></stxt-svg-icon>
      </ng-container>
    </ng-container>
  </div>
  <div
    *ngIf="isError; else hint"
    [class.invalid-message]="isError"
    class="input-custom-error-message supporting-text"
  >
    <stxt-svg-icon [iconConfig]="errorIcon" class="error_icon"></stxt-svg-icon>
    <p>
      {{ inputConfig.supportingText.text }}
      <button
        *ngIf="inputConfig.supportingText?.buttonText"
        (click)="inputConfig.supportingText?.buttonAction()"
        (keydown.enter)="inputConfig.supportingText?.buttonAction()"
        tabindex="0"
      >
        {{ inputConfig.supportingText.buttonText }}
      </button>
    </p>
  </div>
  <ng-template #hint>
    <div
      *ngIf="
        inputConfig.hintText ||
        (inputConfig.supportingText?.text && inputConfig.type === EInputCustomType.Password)
      "
      class="supporting-text"
    >
      <p
        [ngClass]="{ 'underline-hint': inputConfig.hintText?.isLink }"
        (keydown.enter)="inputConfig?.hintText?.buttonAction()"
        (click)="inputConfig.hintText?.buttonAction()"
        tabindex="0"
      >
        {{ inputConfig.hintText?.text || inputConfig.supportingText?.text }}
      </p>
    </div>
  </ng-template>
</div>
